var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reply-content-section"},[_c('pre',{staticClass:"pre"},[_vm._v("  "+_vm._s(_vm.replyBody)+"\n  ")]),_c('div',{staticClass:"replyer-time"},[_c('label',{staticClass:"replyer-time-label"},[_vm._v(_vm._s(_vm.rePlyTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }